import { openBlock as t, createElementBlock as l, createStaticVNode as h } from "vue";
const a = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, e = /* @__PURE__ */ h('<path fill="#F0F0F0" d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"></path><path fill="#FFDA44" d="m10.81 27.826-4.95 6.315A19.935 19.935 0 0 0 20 40c8.268 0 15.363-5.018 18.409-12.174H10.81Z"></path><path fill="#496E2D" d="M38.44 12.246C35.41 5.052 28.296 0 20 0A19.935 19.935 0 0 0 5.86 5.859l5.008 6.387H38.44Z"></path><path fill="#000" d="M4.348 14.71v10.507H39.31A20.01 20.01 0 0 0 40 20a20.01 20.01 0 0 0-.709-5.29H4.348Z"></path><path fill="#A2001D" d="M5.858 5.858c-7.81 7.81-7.81 20.474 0 28.284L20 20 5.858 5.858Z"></path><path fill="#FFDA44" d="m8.094 14.783 1.295 3.985h4.191l-3.39 2.464 1.295 3.985-3.39-2.463-3.391 2.463 1.295-3.985-3.39-2.464h4.19l1.295-3.985Z"></path><path fill="#F0F0F0" d="M4.305 20h7.58v3.478h-7.58V20Z"></path><path fill="#000" d="m13.32 16.012-1.23-1.23-3.995 3.997-3.996-3.996-1.23 1.23 4 3.992-4 4 1.23 1.212 3.996-3.988 3.996 3.988 1.23-1.213-4-4 4-3.992Z"></path>', 8), p = [
  e
];
function o(i, c) {
  return t(), l("svg", a, [...p]);
}
const n = { render: o };
export {
  n as default,
  o as render
};
